module.exports = __webpack_public_path__ + "img/2.007e9350.png";